import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const CalculatorOutlined = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function CalculatorOutlined({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <g fill="currentColor">
          <path d="M13 12h-2v2h2v-2ZM7 12h2v2H7v-2ZM17 12h-2v2h2v-2ZM11 16h2v2h-2v-2ZM9 16H7v2h2v-2ZM15 16h2v2h-2v-2Z" />
          <path fillRule="evenodd" clipRule="evenodd" d="M2.5 1v17c0 2.76 2.24 5 5 5h9c2.76 0 5-2.24 5-5V1h-19Zm17 17c0 1.65-1.35 3-3 3h-9c-1.65 0-3-1.35-3-3V9.5h15V18ZM4.5 7.5V3h15v4.5h-15Z" />
        </g>
      </svg>;
}) as ForwardedIconComponent);
export default CalculatorOutlined;